import React, { useEffect, useMemo, useState } from "react";
import { AbsatAppsList } from "../components/absat-apps/AbsatAppsList";
import { useCurrent } from "../hooks";
import { useTranslation } from "react-i18next";

const DashBoard = () => {
  const { t } = useTranslation("global");
  const [refreshKey, setRefreshKey] = useState(0);
  const { currentCompany, currentLangId } = useCurrent();
  const companyLogo = useMemo(() => {
    const logo = currentCompany?.logo || "/defualtlogo.png";
    if (!currentCompany?.logo) return logo;
    const separator = logo.includes("?") ? "&" : "?";
    return `${logo}${separator}v=${encodeURIComponent(`${currentCompany?._id || "company"}-${refreshKey}`)}`;
  }, [currentCompany?._id, currentCompany?.logo, refreshKey]);
  const companyName =
    currentCompany?.name?.find?.((name) => name?.lang === currentLangId)?.text ||
    currentCompany?.name?.find?.((name) => name?.lang === "ar")?.text ||
    currentCompany?.name?.find?.((name) => name?.lang === "en")?.text ||
    currentCompany?.name?.[0]?.text;

  useEffect(() => {
    const refreshCompanyLogo = () => setRefreshKey((value) => value + 1);

    window.addEventListener("pageshow", refreshCompanyLogo);
    document.addEventListener("visibilitychange", refreshCompanyLogo);

    return () => {
      window.removeEventListener("pageshow", refreshCompanyLogo);
      document.removeEventListener("visibilitychange", refreshCompanyLogo);
    };
  }, []);

  return (
    <>
      <div className="h-[81vh] flex flex-col mb-5 flex-grow justify-evenly relative items-center overflow-scroll">
        <div className="z-20 flex flex-col items-center gap-2 my-3 mb-0 pb-3 text-center">
          <img
            src={companyLogo}
            className="max-w-[250px] max-h-[120px] w-full h-full object-contain"
            alt={companyName || "Company Logo"}
            onError={(event) => {
              event.currentTarget.src = "/defualtlogo.png";
            }}
          />
          {companyName && (
            <div className="text-lg font-bold text-[#251658]">
              {companyName}
            </div>
          )}
        </div>
        <div className="apps w-[100%] gap-2 flex flex-col justify-center items-center">
          <div className="z-30 text-center font-bold text-[23px] text-[#251658]">
            {t("Dashboard.appsTitle")}
          </div>
          <div className="z-30 text-center mb-1 text-[#251658]">
            {t("Dashboard.appsSubtitle")}
          </div>
          <AbsatAppsList />
        </div>
      </div>
    </>
  );
};

export default DashBoard;
